import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import '../Customer/Customer.css';

const ExpenseHeadCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        Remarks: '',
        IsExpenseOrIncome: false,
        CompanyId: companyId,
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setErrorMessage('');

        if (!formData.Name) {
            setErrorMessage('Name is required!');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            ...formData,
            CreatedBy: userId,
            CompanyId: companyId,
        };

        postData('ExpenseHeadApi', CreateData, token)
            .then(() => {
                setSuccessMessage('Account Head created successfully!');
                history.push('/ExpenseHeadIndex');
            })
            .catch((error) => {
                console.error('Error creating record:', error);
                setErrorMessage('Failed to create account head.');
                setIsLoading(false);
            });
    };

    return (
        <div className="form-container">
            <div className="form-card">
                {/* Header */}
                <div className="form-header">
                    <h1 className="form-title">Create Account Head</h1>
                    <div className="form-actions">
                        <Link to="/ExpenseHeadIndex" className="btn-back">
                            <ArrowBackIcon fontSize="small" />
                            Back to List
                        </Link>
                        <button className="btn-save" onClick={submitData} disabled={isLoading}>
                            {isLoading ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <>
                                    <SaveIcon fontSize="small" />
                                    Save
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Messages */}
                {errorMessage && <div className="message error">{errorMessage}</div>}
                {successMessage && <div className="message success">{successMessage}</div>}

                {/* Form Body */}
                <div className="form-body">
                    {/* Row 1 - Name */}
                    <div className="form-row">
                        <div className="form-group full-width">
                            <label className="form-label">Name *</label>
                            <input
                                className="form-input"
                                name="Name"
                                value={formData.Name || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter account head name"
                                maxLength={150}
                            />
                        </div>
                    </div>

                    {/* Row 2 - Remarks and Type */}
                    <div className="form-row">
                        <div className="form-group" style={{ flex: 2 }}>
                            <label className="form-label">Remarks</label>
                            <input
                                className="form-input"
                                name="Remarks"
                                value={formData.Remarks || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter remarks"
                                maxLength={200}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Type</label>
                            <div style={{ display: 'flex', gap: '24px', alignItems: 'center', height: '42px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', color: '#475569', cursor: 'pointer' }}>
                                    <input
                                        type="radio"
                                        name="IsExpenseOrIncome"
                                        value={true}
                                        checked={formData.IsExpenseOrIncome === true}
                                        onChange={handleChange}
                                        style={{ width: '18px', height: '18px', accentColor: '#059669' }}
                                    />
                                    <span style={{ fontWeight: '500', color: '#059669' }}>Income</span>
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', color: '#475569', cursor: 'pointer' }}>
                                    <input
                                        type="radio"
                                        name="IsExpenseOrIncome"
                                        value={false}
                                        checked={formData.IsExpenseOrIncome === false}
                                        onChange={handleChange}
                                        style={{ width: '18px', height: '18px', accentColor: '#dc2626' }}
                                    />
                                    <span style={{ fontWeight: '500', color: '#dc2626' }}>Expense</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpenseHeadCreate;
